<template>
  <div class="language-selector">
    <!--External selector-->
    <div class="external" v-if="type">
      <el-dropdown @command="onSelect">
        <span class="el-dropdown-link">
          {{ $t(language.label) }} <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item  v-for="(item, index) in languages" :key="index" :command="item">{{ $t(item.label) }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--Internal selector-->
    <div class="internal" v-else>
      <select-picker :options="languages" :labelValue="'label'" :clearable="false" :translate="true" v-model="language" @change="onSelect"></select-picker>
    </div>
  </div>
</template>

<style lang="scss">
  .language-selector {
    .external {
      .el-dropdown-link {
        font-size: 14px;
        cursor: pointer;
        // color: white;
      }
      .el-icon-arrow-down {
        font-size: 14px;
      }
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'language-selector',
  components: {
    selectPiker: () => import('@/components/Inputs/Select.vue')
  },
  props: {
    type: null,
    formRef: null
  },
  data () {
    return {
      language: {},
      languages: [
        { id: 1, label: 'spanish', value: 'es' },
        { id: 2, label: 'english', value: 'en' },
        { id: 3, label: 'portuguese', value: 'pt' }
      ]
    }
  },
  computed: {
    ...mapGetters('auth', { langStorage: 'lang' })
  },
  methods: {
    init () {
      const currentLang = this.langStorage ? this.langStorage : this.$i18n.locale
      this.language = this.languages.find(lang => lang.value === currentLang)
      this.setLanguage(this.language.value)
    },
    onSelect (item) {
      this.language = item
      this.setLanguage(this.language.value)
      this.changeTextValidators()
      this.$emit('reload')
    },
    setLanguage (value) {
      this.$store.commit('auth/setLang', value)
    },
    changeTextValidators () {
      if (this.formRef) {
        this.formRef.validate().then().catch(err => {})
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
